export default __webpack_public_path__ + "static/thumb-landscape-5684af0e0ae6b295abc863bc6bc32224.jpg";